import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../Login/firebase";
import apiClient from "../../utils/apiClient";
import ShowStrategyData from "./ShowStrategyData";
import server from "../../utils/serverConfig";

export default function StrategyWise() {
  const [user] = useAuthState(auth);

  const [liveOrders, setLiveOrders] = useState([]);
  
  const [positionsOrders, setPositionsOrders] = useState([]);
  const [accountName, setAccountName] = useState();


  const liveOrdersData = () => {
    let config = {
      method: "get",

      url: `${server.godseye.baseUrl}live_orders_data`,
    };

    apiClient
      .request(config)
      .then((response) => {
        setLiveOrders(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

 

  const getAccountName = () => {
    let config = {
      method: "get",
      url: `${server.godseye.baseUrl}fyers-user-mapping`,
      headers: {
        "Content-Type": "application/json",
      },
    };

    apiClient
      .request(config)
      .then((response) => {
        setAccountName(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [allUser, setAllUser] = useState([]);

  const getAllAccountUser = () => {
    let config = {
      method: "get",
      url: "/api/fyers-user-token",
      headers: {
        "Content-Type": "application/json",
      },
    };

    apiClient
      .request(config)
      .then((response) => {
        setAllUser(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    liveOrdersData();
    // livePoistionsData();
    getAccountName();
    getAllAccountUser();
  }, []);

//   const fecthLiveDataFromWebSocket = () => {
//     // Create a WebSocket instance
//     const ws = new WebSocket("ws://godseye.server.sypto.xyz/ws");

//     // WebSocket onopen event
//     ws.onopen = () => {
//       console.log("WebSocket connection opened");
//     };

//     // WebSocket onmessage event
//     ws.onmessage = (event) => {
//       console.log("WebSocket message received:", event.data);
//       // Handle the received message as needed
//       setPositionsOrders(event.data);
//     };

//     // WebSocket onclose event
//     ws.onclose = () => {
//       console.log("WebSocket connection closed");
//     };

//     // Clean up WebSocket on component unmount
//     return () => {
//       ws.close();
//     };
//   };

//   useEffect(() => {
//     fecthLiveDataFromWebSocket();
//   }, [positionsOrders]);
 
return (
    <DashboardLayout>
      <div className="flex flex-col relative  w-full max-h-screen">
        {/* <div className="grid grid-cols-3 gap-4">
          <div className="flex flex-col items-center justify-center  w-full bg-gray-200 rounded-md h-[100px]">
            <h3 className="text-xl font-semibold text-gray-900">Live PNL</h3>
            <p className="text-3xl font-bold text-green-500">+20K</p>
          </div>
          <div className="flex flex-col items-center justify-center  w-full bg-gray-200 rounded-md h-[100px]">
            <h3 className="text-xl font-semibold text-gray-900">
              Position Count
            </h3>
            <p className="text-3xl font-bold text-gray-900">40</p>
          </div>
          <div className="flex flex-col items-center justify-center  w-full bg-gray-200 rounded-md h-[100px]">
            <h3 className="text-xl font-semibold text-gray-900">
              Orders Count
            </h3>
            <p className="text-3xl font-bold text-gray-900">20</p>
          </div>
          
        </div> */}

        <div className="flex flex-col flex-1 ">
          <ShowStrategyData
            liveOrders={liveOrders}
            // positionsOrders={positionsOrders}
            accountName={accountName}
            allUser={allUser && allUser}
          />
        </div>
      </div>
    </DashboardLayout>
  );
}
